import {Table, Typography} from "antd";
import React from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import NextButton from "../../tech/next_button";

export const VisitRemains = (props) => {
    const {t} = useTranslation()

    const columns = [
        {
            title: t('ID'),
            dataIndex: 'id',
        },
        {
            title: "",
            width:'7%',
            render: (record) => {
                return(
                    <div className={'div-next-button'}>
                        <Link to={`/site/app/remains_trade_points/${record.id}`} state={{from: `/site/app/visits/${props.visitId}`}}>
                            <NextButton/>
                        </Link>
                    </div>
                )
            }
        }
    ]

    return (
        <>
            <Typography.Title level={5} style={{marginTop:'40pt'}}>{t('remains_trade_points')}</Typography.Title>
            <Table
                columns={columns}
                dataSource={props.data}
                rowKey="id"
                loading={props.wait}
                pagination={false}
                size={"small"}
                // onRow={(record, rowIndex) => {
                //     return {
                //         onClick: event => {
                //             // if (user.role_id === 1) {
                //             navigate(`/app/remains_trade_points/${record.id}`,
                //                 {
                //                     state: {
                //                         from: `/app/visits/${props.visitId}`
                //                     }
                //                 })
                //             // }
                //         },
                //     };
                // }}
            />
        </>
    )

}